import { render } from "./CustomRadioItem.vue?vue&type=template&id=87263bf0"
import script from "./CustomRadioItem.vue?vue&type=script&lang=js"
export * from "./CustomRadioItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__